"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from)) if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
      get: () => from[key],
      enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
    });
  }
  return to;
};
var __toCommonJS = mod => __copyProps(__defProp({}, "__esModule", {
  value: true
}), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  MAX_Z_INDEX: () => MAX_Z_INDEX,
  ariaAttr: () => ariaAttr,
  contains: () => contains,
  createScope: () => createScope,
  dataAttr: () => dataAttr,
  getActiveElement: () => getActiveElement,
  getByText: () => getByText,
  getByTypeahead: () => getByTypeahead,
  getComputedStyle: () => getComputedStyle,
  getDocument: () => getDocument2,
  getEventTarget: () => getEventTarget,
  getParent: () => getParent,
  getPlatform: () => getPlatform,
  getScrollParent: () => getScrollParent,
  getScrollParents: () => getScrollParents,
  getWindow: () => getWindow,
  indexOfId: () => indexOfId,
  isApple: () => isApple,
  isDom: () => isDom,
  isEditableElement: () => isEditableElement,
  isFirefox: () => isFirefox,
  isHTMLElement: () => isHTMLElement,
  isIPhone: () => isIPhone,
  isIos: () => isIos,
  isMac: () => isMac,
  isSafari: () => isSafari,
  isSelfEvent: () => isSelfEvent,
  isTouchDevice: () => isTouchDevice,
  itemById: () => itemById,
  nextById: () => nextById,
  nextTick: () => nextTick,
  prevById: () => prevById,
  query: () => query,
  queryAll: () => queryAll,
  raf: () => raf
});
module.exports = __toCommonJS(src_exports);

// src/attrs.ts
var dataAttr = guard => {
  return guard ? "" : void 0;
};
var ariaAttr = guard => {
  return guard ? "true" : void 0;
};

// src/is-html-element.ts
function isHTMLElement(value) {
  return typeof value === "object" && (value === null || value === void 0 ? void 0 : value.nodeType) === Node.ELEMENT_NODE && typeof (value === null || value === void 0 ? void 0 : value.nodeName) === "string";
}

// src/contains.ts
function contains(parent, child) {
  if (!parent || !child) return false;
  if (!isHTMLElement(parent) || !isHTMLElement(child)) return false;
  return parent === child || parent.contains(child);
}
var isSelfEvent = event => contains(event.currentTarget, event.target);

// src/create-scope.ts
var getDocument = node => {
  var _node$ownerDocument;
  if (node.nodeType === Node.DOCUMENT_NODE) return node;
  return (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : document;
};
function createScope(methods) {
  const screen = {
    getRootNode: ctx => {
      var _ctx$getRootNode, _ctx$getRootNode2;
      return (_ctx$getRootNode = (_ctx$getRootNode2 = ctx.getRootNode) === null || _ctx$getRootNode2 === void 0 ? void 0 : _ctx$getRootNode2.call(ctx)) !== null && _ctx$getRootNode !== void 0 ? _ctx$getRootNode : document;
    },
    getDoc: ctx => getDocument(screen.getRootNode(ctx)),
    getWin: ctx => {
      var _screen$getDoc$defaul;
      return (_screen$getDoc$defaul = screen.getDoc(ctx).defaultView) !== null && _screen$getDoc$defaul !== void 0 ? _screen$getDoc$defaul : window;
    },
    getActiveElement: ctx => screen.getDoc(ctx).activeElement,
    getById: (ctx, id) => screen.getRootNode(ctx).getElementById(id)
  };
  return {
    ...screen,
    ...methods
  };
}

// src/env.ts
var isDocument = el => el.nodeType === Node.DOCUMENT_NODE;
function getDocument2(el) {
  var _el$ownerDocument;
  if (isDocument(el)) return el;
  return (_el$ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el$ownerDocument !== void 0 ? _el$ownerDocument : document;
}
function getWindow(el) {
  var _el$ownerDocument$def;
  return (_el$ownerDocument$def = el === null || el === void 0 ? void 0 : el.ownerDocument.defaultView) !== null && _el$ownerDocument$def !== void 0 ? _el$ownerDocument$def : window;
}

// src/get-active-element.ts
function getActiveElement(el) {
  let activeElement = el.ownerDocument.activeElement;
  while ((_activeElement = activeElement) !== null && _activeElement !== void 0 && _activeElement.shadowRoot) {
    var _activeElement;
    const el2 = activeElement.shadowRoot.activeElement;
    if (el2 === activeElement) break;else activeElement = el2;
  }
  return activeElement;
}

// src/get-by-id.ts
function itemById(v, id) {
  return v.find(node => node.id === id);
}
function indexOfId(v, id) {
  const item = itemById(v, id);
  return item ? v.indexOf(item) : -1;
}
function nextById(v, id) {
  let loop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  let idx = indexOfId(v, id);
  idx = loop ? (idx + 1) % v.length : Math.min(idx + 1, v.length - 1);
  return v[idx];
}
function prevById(v, id) {
  let loop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  let idx = indexOfId(v, id);
  if (idx === -1) return loop ? v[v.length - 1] : null;
  idx = loop ? (idx - 1 + v.length) % v.length : Math.max(0, idx - 1);
  return v[idx];
}

// src/get-by-text.ts
var getValueText = item => {
  var _ref, _item$dataset$valuete;
  return (_ref = (_item$dataset$valuete = item.dataset.valuetext) !== null && _item$dataset$valuete !== void 0 ? _item$dataset$valuete : item.textContent) !== null && _ref !== void 0 ? _ref : "";
};
var match = (valueText, query2) => valueText.toLowerCase().startsWith(query2.toLowerCase());
var wrap = (v, idx) => {
  return v.map((_, index) => v[(Math.max(idx, 0) + index) % v.length]);
};
function getByText(v, text, currentId) {
  const index = currentId ? indexOfId(v, currentId) : -1;
  let items = currentId ? wrap(v, index) : v;
  const isSingleKey = text.length === 1;
  if (isSingleKey) {
    items = items.filter(item => item.id !== currentId);
  }
  return items.find(item => match(getValueText(item), text));
}

// src/get-by-typeahead.ts
function getByTypeaheadImpl(_items, options) {
  const {
    state,
    activeId,
    key,
    timeout = 350
  } = options;
  const search = state.keysSoFar + key;
  const isRepeated = search.length > 1 && Array.from(search).every(char => char === search[0]);
  const query2 = isRepeated ? search[0] : search;
  let items = _items.slice();
  const next = getByText(items, query2, activeId);
  function cleanup() {
    clearTimeout(state.timer);
    state.timer = -1;
  }
  function update(value) {
    state.keysSoFar = value;
    cleanup();
    if (value !== "") {
      state.timer = +setTimeout(() => {
        update("");
        cleanup();
      }, timeout);
    }
  }
  update(search);
  return next;
}
var getByTypeahead = /* @__PURE__ */Object.assign(getByTypeaheadImpl, {
  defaultOptions: {
    keysSoFar: "",
    timer: -1
  },
  isValidEvent: isValidTypeaheadEvent
});
function isValidTypeaheadEvent(event) {
  return event.key.length === 1 && !event.ctrlKey && !event.metaKey;
}

// src/get-computed-style.ts
var styleCache = /* @__PURE__ */new WeakMap();
function getComputedStyle(el) {
  if (!styleCache.has(el)) {
    const win = el.ownerDocument.defaultView || window;
    styleCache.set(el, win.getComputedStyle(el));
  }
  return styleCache.get(el);
}

// src/get-event-target.ts
function getEventTarget(event) {
  var _event$composedPath$, _event$composedPath;
  return (_event$composedPath$ = (_event$composedPath = event.composedPath) === null || _event$composedPath === void 0 ? void 0 : _event$composedPath.call(event)[0]) !== null && _event$composedPath$ !== void 0 ? _event$composedPath$ : event.target;
}

// src/get-scroll-parent.ts
function isScrollParent(el) {
  const win = el.ownerDocument.defaultView || window;
  const {
    overflow,
    overflowX,
    overflowY
  } = win.getComputedStyle(el);
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function getParent(el) {
  if (el.localName === "html") return el;
  return el.assignedSlot || el.parentElement || el.ownerDocument.documentElement;
}
function getScrollParent(el) {
  if (["html", "body", "#document"].includes(el.localName)) {
    return el.ownerDocument.body;
  }
  if (isHTMLElement(el) && isScrollParent(el)) {
    return el;
  }
  return getScrollParent(getParent(el));
}
function getScrollParents(el) {
  let list = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const parent = getScrollParent(el);
  const isBody = parent === el.ownerDocument.body;
  const win = parent.ownerDocument.defaultView || window;
  const target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(parent) ? parent : []) : parent;
  const parents = list.concat(target);
  return isBody ? parents : parents.concat(getScrollParents(getParent(target)));
}

// src/is-editable-element.ts
function isEditableElement(el) {
  if (el == null || !isHTMLElement(el)) {
    return false;
  }
  try {
    const win = el.ownerDocument.defaultView || window;
    return el instanceof win.HTMLInputElement && el.selectionStart != null || /(textarea|select)/.test(el.localName) || el.isContentEditable;
  } catch {
    return false;
  }
}

// src/platform.ts
var isDom = () => typeof document !== "undefined";
function getPlatform() {
  var _agent$platform;
  const agent = navigator.userAgentData;
  return (_agent$platform = agent === null || agent === void 0 ? void 0 : agent.platform) !== null && _agent$platform !== void 0 ? _agent$platform : navigator.platform;
}
var pt = v => isDom() && v.test(getPlatform());
var ua = v => isDom() && v.test(navigator.userAgent);
var vn = v => isDom() && v.test(navigator.vendor);
var isTouchDevice = () => isDom() && !!navigator.maxTouchPoints;
var isMac = () => pt(/^Mac/) && !isTouchDevice();
var isIPhone = () => pt(/^iPhone/);
var isSafari = () => isApple() && vn(/apple/i);
var isFirefox = () => ua(/firefox\//i);
var isApple = () => pt(/mac|iphone|ipad|ipod/i);
var isIos = () => isApple() && !isMac();

// src/query.ts
function queryAll(root, selector) {
  var _root$querySelectorAl;
  return Array.from((_root$querySelectorAl = root === null || root === void 0 ? void 0 : root.querySelectorAll(selector)) !== null && _root$querySelectorAl !== void 0 ? _root$querySelectorAl : []);
}
function query(root, selector) {
  return root === null || root === void 0 ? void 0 : root.querySelector(selector);
}

// src/raf.ts
function nextTick(fn) {
  const set = /* @__PURE__ */new Set();
  function raf2(fn2) {
    const id = globalThis.requestAnimationFrame(fn2);
    set.add(() => globalThis.cancelAnimationFrame(id));
  }
  raf2(() => raf2(fn));
  return function cleanup() {
    set.forEach(fn2 => fn2());
  };
}
function raf(fn) {
  const id = globalThis.requestAnimationFrame(fn);
  return () => {
    globalThis.cancelAnimationFrame(id);
  };
}

// src/index.ts
var MAX_Z_INDEX = 2147483647;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  MAX_Z_INDEX,
  ariaAttr,
  contains,
  createScope,
  dataAttr,
  getActiveElement,
  getByText,
  getByTypeahead,
  getComputedStyle,
  getDocument,
  getEventTarget,
  getParent,
  getPlatform,
  getScrollParent,
  getScrollParents,
  getWindow,
  indexOfId,
  isApple,
  isDom,
  isEditableElement,
  isFirefox,
  isHTMLElement,
  isIPhone,
  isIos,
  isMac,
  isSafari,
  isSelfEvent,
  isTouchDevice,
  itemById,
  nextById,
  nextTick,
  prevById,
  query,
  queryAll,
  raf
});